import Sidebar from "../Sidebar";

const DashboardLayout = ({ children }) => {
  const hideSidebar = () => {
    document.getElementById("sidebar").classList.add("max-lg:hidden");
    document.getElementById("sidebarTriggerRef").classList.remove("hidden");
  };

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar />
      <main
        className="flex-1 overflow-y-auto"
        onClick={hideSidebar}
        style={{ height: window.innerHeight }}
      >
        {children}
      </main>
    </div>
  );
};

export default DashboardLayout;
